<template>
  <div>{{date}}</div>
</template>

<script>
export default {
    data () {
        return {
            months: ["jaanuar", "veebruar", "märts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
        }
    },
    computed: {
        date () {
            var d = new Date();
            return d.getDate() + ". " + this.months[d.getMonth()];
        }
    }
}
</script>

<style>

</style>